import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import Heading from '@atlaskit/heading';
import MagicWandIcon from '@atlaskit/icon/core/magic-wand';
import Image from '@atlaskit/image';
import { Flex } from '@atlaskit/primitives/compiled';
import { noDynamicCards } from '@atlassian/company-hub-common/assets';

import { messages } from './messages';

type EmptyStateContainerProps = { startCreateFilters: () => void };

export const EmptyStateContainer = ({ startCreateFilters }: EmptyStateContainerProps) => {
	return (
		<Flex
			direction="column"
			justifyContent="center"
			alignItems="center"
			gap="space.200"
			testId="empty-state-container"
		>
			<Image src={noDynamicCards} alt="" testId="no-dynamic-cards-image" />

			<Heading size="medium">
				<FormattedMessage {...messages.noDynamicCards} />
			</Heading>

			<Button shouldFitContainer appearance="primary" onClick={startCreateFilters}>
				<Flex gap="space.100" justifyContent="center">
					<MagicWandIcon label="" />
					<FormattedMessage {...messages.buildDynamicCards} />
				</Flex>
			</Button>
		</Flex>
	);
};
